// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
// Support component names relative to this directory:
import "core-js/stable";
import "regenerator-runtime/runtime";
import "whatwg-fetch";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import setupCSRFToken from "../setupCSRFToken";

window.addEventListener("DOMContentLoaded", setupCSRFToken);

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  environment: process.env.ENVIRONMENT,
  release: process.env.RELEASE,
  tracesSampleRate: 0.2,
  allowUrls: ["hiring-hub.com"],
});

const componentRequireContext = require.context("src/components", true);
/* eslint-disable-next-line @typescript-eslint/no-var-requires */
const ReactRailsUJS = require("react_ujs");

/* eslint-disable-next-line react-hooks/rules-of-hooks */
ReactRailsUJS.useContext(componentRequireContext);
